import React, {useEffect, useState} from "react";
import Datetime from "react-datetime";
import moment from "moment/moment";
import {deepCopyObject} from "../../../helper/helper";

const InvoiceIadeLine = (props) => {
    const {listener, data} = props;
    const [trdDocInvoiceIadeLines, setTrdDocInvoiceIadeLines] = useState([]);

    useEffect(() => {
        if (data === null || data.length < 0) {
            let iadeLine = {
                recordId: null,
                invoiceNumber: null,
                issueDate: moment()
            }
            trdDocInvoiceIadeLines.push(iadeLine);
        } else {
            setTrdDocInvoiceIadeLines(data);
        }
    }, []);

    useEffect(() => {
        if (data !== null && data.length > 0) {
            setTrdDocInvoiceIadeLines(data)
        }
    }, [data]);

    const onChange = (data, index) => {
        if (data.name === "invoiceNumber") {
            const newList = deepCopyObject(trdDocInvoiceIadeLines);

            newList[index].invoiceNumber = data.value;
            setTrdDocInvoiceIadeLines(newList);
            listener(newList);
        } else if (data.name === "issueDate") {
            const newList = deepCopyObject(trdDocInvoiceIadeLines);

            newList[index].issueDate = data.value;
            setTrdDocInvoiceIadeLines(newList);
            listener(newList);
        }
    }

    const addInvoiceIadeLine = () => {
        let line = deepCopyObject(trdDocInvoiceIadeLines);
        line.push({
            recordId: null,
            invoiceNumber: null,
            issueDate: moment()
        });
        setTrdDocInvoiceIadeLines(line);
    }

    const removeInvoiceIadeLine = (index) => {
        let line = deepCopyObject(trdDocInvoiceIadeLines);
        line.splice(index, 1);
        setTrdDocInvoiceIadeLines(line);
    }

    return (
        <div className="col-sm-12">
            <div className="card-header" style={{padding: '1em 0 1em 0'}}>
                <div className="row">
                    <div className="col-sm-3 row" style={{float: 'left'}}>
                        <h4 className="card-title" style={{display: 'inline'}}>İadeye Konu Olan Fatura
                            Bilgileri</h4>
                    </div>
                    <div className="col-sm-9" style={{float: 'right'}}>
                        <button type="button"
                                style={{
                                    float: 'right', padding: '10px 39px 10px 16px',
                                    marginRight: '-15px'
                                }}
                                className="TekBtn ekle hizala pull-right  btn-default btn-md "
                                onClick={(e) => addInvoiceIadeLine()}>Satır Ekle
                        </button>
                    </div>
                </div>
            </div>
            <div className="card-body" style={{padding: '1em 0 1em 0'}}>
                <div className="row invoiceLines">
                    <div className="col-sm-12" style={{padding: '0'}}>
                        <table className="" style={{textAlign: 'center'}}>
                            <thead>
                            <tr style={{backgroundColor: '#ebedf0'}}>
                                <th width="2%">#</th>
                                <th width="12%">Fatura Numarası</th>
                                <th width="5%">Düzenlenme Tarihi</th>
                                <th width="2%">İşlemler</th>
                            </tr>
                            </thead>
                            <tbody>
                            {trdDocInvoiceIadeLines.map((trdDocInvoiceIadeLine, index) =>
                                <tr key={index}>
                                    <td data-label={"#"}>{index + 1}</td>
                                    <td data-label={"Fatura Numarası"}>
                                        <input id={'invoiceNumber_' + index}
                                               type="text"
                                               maxLength="16"
                                               className="form-control"
                                               value={trdDocInvoiceIadeLine?.invoiceNumber}
                                               placeholder="Fatura No giriniz"
                                               onChange={(e) => onChange({
                                                   value: e.target.value,
                                                   name: "invoiceNumber"
                                               }, index)}/>
                                    </td>
                                    <td data-label={"Düzenlenme Tarihi"}>
                                        <Datetime locale="tr"
                                                  className="datepicker"
                                                  input={true}
                                                  inputProps={{id: 'issueDate'}}
                                                  closeOnSelect={true}
                                                  defaultValue={moment()}
                                                  timeFormat={false}
                                                  dateFormat="DD-MM-YYYY"
                                                  value={moment(trdDocInvoiceIadeLine?.issueDate)}
                                                  onChange={(e) => onChange({
                                                      value: e,
                                                      name: "issueDate"
                                                  }, index)}/>
                                    </td>
                                    <td data-label={"İşlemler"}>
                                        <button type="button" className="Btn temizle"
                                                style={{margin: "0", background: '#FFCCCC'}}
                                                disabled={trdDocInvoiceIadeLines.length < 2}
                                                onClick={() => removeInvoiceIadeLine(index)}/>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvoiceIadeLine;